import React from "react";

import { VacancyInfoWithConfiguration } from "./VacancyInfoWithConfiguration";

import { ClientTypeEnum } from "@/types/client/ClientType";
import { VacancyType } from "@/types/vacancy/VacancyType";

type VacancyInfoProps = {
  vacancy: VacancyType;
  clientId?: string;
};

const VacancyInformation: React.FC<VacancyInfoProps> = ({
  vacancy,
  clientId,
}) => {
  const isFeedClient = vacancy.origin == ClientTypeEnum.FEED;

  return (
    <VacancyInfoWithConfiguration
      vacancy={vacancy}
      isFeedClient={isFeedClient}
      clientId={clientId}
    />
  );
};

export default VacancyInformation;
